<template>
    <div class="bg-white pb-3 p-2 shadow-sm rounded-lg">
        <form id="submit_form" @submit.prevent="saveSetting" v-if="!loading && bank_accounts">
            <div
                class="container pt-3 pb-4 my-4 border in-border-header px-4"
                v-for="(value, key) in banks_list"
                :key="key"
            >
                <div class="row">
                    <single-switching-setting
                        v-if="switching_settings"
                        :bank_id="value"
                        :accounts="bank_accounts[value]"
                    ></single-switching-setting>
                </div>
            </div>
            <div v-if="$can('change-general-settings', 'wallet')" class="col-12 mt-5 pt-5">
                <div>
                    <button class="btn btn-success ml-auto"
                            type="submit"
                            v-text="$t('btn.submit_changes')"
                    ></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {accountingService, walletService} from "@/common/api.service";
import SingleSwitchingSetting from "@/views/wallets/AyandeWallets/Admin/components/single-switching-setting.vue";
import {mapGetters} from "vuex";

export default {
    components: {SingleSwitchingSetting},
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapGetters('wallet', ['loading', 'switching_settings'])
    },
    data() {
        return {
            banks_list: null,
            bank_accounts: null,
        };
    },
    methods: {
        saveSetting() {
            const updateSwitchingSettings = this.fetch_starshop
                ? walletService.updateStarShopSwitchingSettings
                : walletService.updateSwitchingSettings;

            updateSwitchingSettings({bank_lists: this.switching_settings}).then(
                res => {}
            )
        }
    },
    mounted() {

        let accountBanksList;
        let accountsOfOneBankForSelect;

        if (this.fetch_starshop) {
            accountBanksList = walletService.accountStarShopBanksList;
            accountsOfOneBankForSelect = walletService.getStarShopAllAccountsOfOneBankForSelect;
        } else  {
            accountBanksList = walletService.accountBanksList;
            accountsOfOneBankForSelect = walletService.getAllAccountsOfOneBankForSelect;
        }

        accountBanksList().then(res => {
            this.banks_list = res.data.data;
            this.fetch_starshop
                ? this.$store.dispatch("wallet/fetchStarShopSwitchingSettings")
                : this.$store.dispatch("wallet/fetchSwitchingSettings");
            this.counter ++;
            this.$forceUpdate();
        });
        accountsOfOneBankForSelect().then(res => {
            this.bank_accounts = res.data.data;
        })
    },
}
</script>
